import {
  Component,
  ChangeDetectionStrategy,
  inject
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import { FileData } from '@shared/models/catalog.service';
import { CustomIcons } from '@shared/models/custom-icons';

@Component({
  selector: 'app-catalog-item-card-files-modal',
  templateUrl: './catalog-item-card-files-modal.component.html',
  styleUrls: ['./catalog-item-card-files-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogItemCardFilesModalComponent {
  icons = CustomIcons;
  data: FileData[] = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<CatalogItemCardFilesModalComponent>);

  public close(): void {
    this.dialogRef.close(false);
  }
}
